var otherFeeToggleConfirmation = function () {
    $(".other-fee-toggle-img").toggle();
    $(".other-sub-fee-confirmation").toggle();
    $(".other-sub-fee").toggle();
    var smallOrderFee = $("#small-order-fee-confirmation td").html().replace("$", "");
    if ($("html").attr("lang") === "fr-CA") {
        smallOrderFee = smallOrderFee.replace(",", ".");
    }
    smallOrderFee = Number(smallOrderFee);

    if (smallOrderFee == 0) {
        $("#small-order-fee-confirmation").css("visibility", "hidden");
    }
};

if ($("#frmOrderConfirmation").length) {
    var $addFavForm = $("#frmFavoriteItem");
    var $removeFavForm = $("#frmUnfavoriteItem");
    var $nameField = $("#nameFavoriteOrder");
    var cartId = "";
    var cartItemId = "";
    var spinnerHTML = '<div class="loader-container-small"><span class="icon icon-subway-mono"></span><div class="loader-outside"></div></div>';

    var query_string_paramter = window.location.href.split("?")[1];
    const urlParams = new URLSearchParams(query_string_paramter);
    if (urlParams.has("ordstatus") == false) {
        orderViewModel.flushCart();
    }
    var $cartDiv = $(".badge-bagcount");
    if ($cartDiv.length > 0) {
        $cartDiv.html("");
        $cartDiv.attr("style", "display: none;");
    }
    var removeFavoriteHandler = function (obj) {
        var $itemContainer = obj.closest(".accordion-item");
        cartItemId = $itemContainer.data("cartitemid");
        cartId = $itemContainer.data("cartid");
        $("#cartItemId", $removeFavForm).val(cartItemId);

        modalClose(false);
        modalShowId("#modal-remove-item");
    };

    var addFavoriteHandler = function (obj) {
        var $itemContainer = obj.closest(".accordion-item");
        cartItemId = $itemContainer.data("cartitemid");
        var productId = $itemContainer.data("productid");
        cartId = $itemContainer.data("cartid");
        var orderedItem = $itemContainer.data("orderitemid");
        var productName = $itemContainer.find("div>.accordion-confirmation-item-name")[0].textContent;

        $("#favoriteProductId", $addFavForm).val(productId);
        $("#orderedItem", $addFavForm).val(orderedItem);
        $("#CartId", $addFavForm).val(cartId);
        $("#Name", $addFavForm).val(productName);
        $("#ProductName", $addFavForm).val(productName);

        modalClose(false);
        $(".fav-name-textbox").val("");
        $("#saveAddFavorite").addClass("disabled");
        $(".fav-character-count").text(60);
        modalShowId("#modal-favorite-item");
    };

    function loyaltyAcquisitionModal() {
        if ($("#loyaltyAcquisition").length) {
            var timeDelay = parseInt($("#loyaltyAcquisition").attr("data-time-interval")) * 1000; //data value converted into milliseconds from seconds
            setTimeout(function () {
                modalShowId("#loyaltyAcquisition");
                $(".loyalty-modal").focus();
                analytics.joinNowModal();
                analytics.attemptTrack(analytics.loyaltyAcquisitionModal.myWayRewardsModal);
            }, timeDelay);
        }
    }

    (function () {
        var currentStore = (orderViewModel.store && orderViewModel.store.id) || 0;
        $("#initStoreId").val(currentStore);

        $(function () {
            var action = $("#frmOrderConfirmation").attr("action");
            $("#subway-spinner").show();

            //Removed the signup url to redirect the sign-up invitation page with prefilled data
            $(".js-top-signup, .js-join-btn, .js-join-now").attr("href", "javascript:void(0)");

            ajaxGetResults(action, "frmOrderConfirmation");
        });

        function signupInvitation() {
            var $signupInvForm = $("#frmSignupInvitation");
            subwayScript.showSpinner();
            let language = $("#scLanguageCode") && $("#scLanguageCode").val() || "en-us";
            $.ajax({
                url: $signupInvForm.attr("action"),
                type: "POST",
                data: $signupInvForm.serialize(),
                success: function (data) {
                    if (data != "") {
                        window.location.href = "/" + language + "/auth/SignUpInvitation?url=" + window.location.href + "&invitation=" + data;
                    } else {
                        window.location.href = "/" + language + "/auth/SignUp";
                    }
                },
                error: function (jqXhr) {
                    window.location.href = "/" + language + "/auth/SignUp";
                },
            });
        }

        function ajaxGetResults(postUrl, formId) {
            $.ajax({
                url: postUrl,
                type: "POST",
                data: $("#" + formId).serialize(),
                success: function (data) {
                    $("#subway-spinner").hide();
                    $("#order-confirmation-page").html(data);
                    //show loyalty modal
                    if ($("#isCurbSideEnable").val() != 1) {
                        loyaltyAcquisitionModal();
                    }

                    isMobileTablet() ? $('#order-details-section .order-txt-mobile').removeClass('d-none') : $('#order-details-section .order-txt-desktop').removeClass('d-none')
                    //For Analytics, new account source tracking
                    if ($("#order-confirmation-page").attr("data-auth") === "1" && orderViewModel.Analytics.signupSource != null && orderViewModel.Analytics.signupSource != "") {
                        analytics.signupSourceTracking(orderViewModel.Analytics.signupSource);
                    }
                    orderViewModel.Analytics.signupSource = "";
                    orderViewModel.cartProducts = [];
                    orderViewModel.promosAndDeals.isPromoCodeApplied = false
                    orderViewModel.save();
                    var orderdDetailsList = $("#ordered-list-details");
                    var $productCartitems = $("li[data-cartitemid]", orderdDetailsList);
                    void 0;
                    analytics.addPageProductAnalytics($productCartitems);

                    $(".js-top-signup, .js-join-btn, .js-join-now").on("click", function () {
                        if ($(this).hasClass("js-join-now")) {
                            analytics.joinNowCTA();
                            analytics.attemptTrack(analytics.loyaltyAcquisitionModal.joinNow);
                            orderViewModel.Analytics.signupSource = analytics.loyaltyAcquisitionModal.joinNow;
                        }
                        if ($(this).hasClass("js-join-btn")) {
                            orderViewModel.Analytics.signupSource = analytics.loyaltyAcquisitionModal.myWayRewardsModal;
                        }
                        if ($(this).hasClass("js-top-signup")) {
                            orderViewModel.Analytics.signupSource = analytics.loyaltyAcquisitionModal.orderConf;
                        }
                        orderViewModel.save();
                        signupInvitation();
                    });

                    //clear the special instruction cookie
                    eraseCookie("om_spec_inst_ck");
                    orderViewModel.promoCode = {}
                    orderViewModel.save()
                    eraseCookie("pickup_time_ready_at");

                    //clear the curb instruction cookie
                    eraseCookie("om_spec_inst_ck_curb");

                    //clear the curb toggle cookie
                    eraseCookie("om_spec_inst_ck_curb_toggle");
                    eraseCookie("CurbSideToggle");

                    if ($("#order-confirmation-page").attr("data-auth") == "1") {
                        //Getting contact information from orderDetails API
                        ////contact information

                        $addFavForm = $("#frmFavoriteItem");
                        $removeFavForm = $("#frmUnfavoriteItem");
                        $nameField = $("#nameFavoriteOrder");

                        $("#saveAddFavorite").click(function () {
                            var favoriteName = $nameField.val().trim();

                            if (!favoriteName) {
                                return false;
                            }

                            $("#Name", $addFavForm).val(favoriteName);

                            $("#subway-spinner").show();

                            $.ajax({
                                url: $addFavForm.attr("action"),
                                type: "POST",
                                data: $addFavForm.serialize(),
                                error: function (jqXhr) {
                                    $("#subway-spinner").hide();
                                    modalClose(true);
                                    modalShowId("#fav-max-limit-modal");
                                },
                                success: function (data) {
                                    //Request responded 200, but did not succeed
                                    if (!data.Success) {
                                        $("#Name", $addFavForm).val("");
                                        $("#nameFavoriteOrder").val("");
                                        modalClose(true);
                                        $("#subway-spinner").hide();

                                        return;
                                    }

                                    var item = $("#CartId", $addFavForm);
                                    var productId = $("#favoriteProductId", $addFavForm).val();
                                    var orderId = $("#orderedItem", $addFavForm).val();
                                    var productName = $("#ProductName", $addFavForm).val();

                                    analytics.favoriteItem(productId);
                                    analytics.favorite(productName, orderId);
                                    if (item.length > 0) {
                                        var $itemListing = $('[data-orderitemid="' + orderId + '"]');

                                        var $iconElement = $(".icon-favorite_border", $itemListing);
                                        var favoriteHeader = $("accordion-confirmation-item-name");
                                        var $itemElement = $(".accordion-confirmation-item-name", $itemListing);
                                        $(".fav-name", $itemListing)[0].innerHTML = $itemElement[0].innerHTML;
                                        $itemElement[0].innerHTML = favoriteName;
                                        $iconElement.removeClass("icon-favorite_border").addClass("icon-favorite").attr("aria-checked", "true");
                                        $iconElement.off("click");
                                    }
                                    $("#Name", $addFavForm).val("");
                                    $("#nameFavoriteOrder").val("");
                                    $(".fav-character-count").text(60);
                                    modalClose(true);
                                    $("#subway-spinner").hide();
                                },
                            });

                            return true;
                        });

                        $(".fav-name-textbox").on("click keyup change", function () {
                            var instructionValue = $(this).val();
                            var maxLength = parseInt($(this).attr("maxlength") || 60);
                            if (instructionValue.length > maxLength) {
                                instructionValue = instructionValue.substring(0, maxLength);
                                $(this).val(instructionValue);
                            }
                            $(".fav-character-count").text(maxLength - instructionValue.length);
                            if($(".fav-name-textbox").val() !=''){
                                $('#saveAddFavorite').attr('aria-label', 'Save button');
                            }else{
                                $('#saveAddFavorite').attr('aria-label', 'Save button unavailable');
                            }
                        });

                        $("#removeFavoriteItem").click(function () {
                            $("#subway-spinner").show();
                            $.ajax({
                                url: $removeFavForm.attr("action"),
                                type: "POST",
                                data: $removeFavForm.serialize(),
                                error: function (jqXhr) {
                                    $("#subway-spinner").hide();
                                    modalClose(true);
                                    subwayScript.showAjaxError(jqXhr);
                                },
                                success: function () {
                                    var item = $("#cartItemId", $removeFavForm);

                                    if (item.length > 0) {
                                        var $itemListing = $('[data-cartitemid="' + item.val() + '"]');
                                        var $iconElement = $(".icon-favorite", $itemListing);

                                        // hide the item description for when it's not a favorite, show the item description when it is a fav

                                        $iconElement.removeClass("icon-favorite").addClass("icon-favorite_border").attr("aria-checked", "false");
                                        $iconElement.off("click");
                                        $iconElement.click(function (event) {
                                            addFavoriteHandler($(event.target));
                                        });
                                    }
                                    modalClose(true);
                                    $("#subway-spinner").hide();
                                },
                            });
                        });


                        // script to select and deselect favorite icon

                        $(".icon-favorite_border").on("click keypress", function (e) {
                            if (e.which === 13 || e.type === "click") {
                                $(window).scrollTop(0);
                                addFavoriteHandler($(this));
                            }
                        });
                    }
                    if (orderViewModel.SSDSNotification) {
                        $("#order-details-section").hide();
                        $(".confirmation-details").show();
                        $('.is-full-class').show();
                        $('.is-half-class').hide();
                        $('.is-empty-class').hide();
                    };
                    $(".show-footer-order-button-mobile-tab").remove();
                    $(".item-header-list .order-confirm-accordion-title-click").addClass("is-expanded");
                    $(".items-ordered-list li .accordion-content").removeClass("is-collapsed");
                    $(".items-ordered-list li .accordion-content").addClass("is-expanded");
                    $(".items-ordered-list li .accordion-content").attr("aria-hidden", "false");

                    analytics.OrderSourceType(orderViewModel.OrderSourceType);
                    if ($(".rewards-way-container-new").length) {
                        if ($(window).width() < 768) {
                            $(".rewards-way-container-new .logo-img img").attr("src", $("#my-rewards-img-mobile").val());
                        } else {
                            $(".rewards-way-container-new .logo-img img").attr("src", $("#my-rewards-img").val());
                        }
                    }
                },
                error: function (jqXhr) {
                    $("#subway-spinner").hide();
                    subwayScript.showAjaxError(jqXhr);
                },
                complete: function () {
                    clearDeliveryFulfillmentType(orderViewModel.orderType);
                },
            });
        }
    })();
    function clearDeliveryFulfillmentType(fulfillmentType) {
        if (fulfillmentType !== null && fulfillmentType.toLowerCase() === "delivery") {
            orderViewModel.hasDeliveryLocator = undefined;
            orderViewModel.store.id = null;
            orderViewModel.store.StoreId = null;
            orderViewModel.save();
        }
    }
}

function generateStoreMap(divid) {
    /*var address = orderViewModel.store.address + " " + orderViewModel.store.city + " " + orderViewModel.store.stateProvCode + " " + orderViewModel.store.storeCountry;*/
    var store_address = $('#store-info-address').val();
    var city = $('#store-info-city').val();
    var stateProvCode = $('#store-info-state').val();
    var storeCountry = $('#store-info-country').val();
    var addressSection = orderViewModel.store.address ? orderViewModel.store.address : store_address;
    var addressCity = orderViewModel.store.city ? orderViewModel.store.city : city;
    var addressState = orderViewModel.store.stateProvCode ? orderViewModel.store.stateProvCode : stateProvCode;
    var addressCountry = orderViewModel.store.storeCountry ? orderViewModel.store.storeCountry : storeCountry;
    var address = addressSection + " " + addressCity + " " + addressState + " " + addressCountry;
    $.getScript("https://maps.googleapis.com/maps/api/js?key="+locatorConfig.getMyMapsKey()+"&libraries=places&v=weekly", function () {
        initGoogleMapMethods = function () {
            let mapId = document.getElementById("orderConfirmationMap");
            var geocoder = new google.maps.Geocoder();
            geocoder.geocode({ address: address }, function (results, status) {
                if (status == google.maps.GeocoderStatus.OK && results) {
                    var lati = results[0].geometry.location.lat();
                    var longi = results[0].geometry.location.lng();
                    var latlng = new google.maps.LatLng(lati, longi);
                    const map = new google.maps.Map(mapId, {
                        center: { lat: lati, lng: longi },
                        mapTypeControl: false,
                        mapTypeControlOptions: {
                            mapTypeIds: [google.maps.MapTypeId.ROADMAP, "map_style"],
                        },
                        draggable: false,
                        disableDoubleClickZoom: true,
                        zoom: 15,
                        disableDefaultUI: true,
                        streetViewControl: false,
                        scaleControl: true,
                        zoomControl: false,
                        panControl: true,
                        styles: [
                            { stylers: [{ visibility: "off" }] },
                            { featureType: "administrative.country", stylers: [{ visibility: "on" }] },
                            { featureType: "administrative.province", stylers: [{ visibility: "on" }] },
                            { featureType: "road", stylers: [{ visibility: "on" }] },
                            { featureType: "water", stylers: [{ visibility: "on" }] },
                        ],
                    });
                    var marker = new google.maps.Marker({
                        position: latlng,
                    });
                    marker.setMap(map);
                }
            });
        };

        initGoogleMapMethods();
    });
}

function getStoreDirection() {
    var ctaText = $("#store-direction-CTA").text().toLowerCase();
    analytics.curbSideModalConfirmationPage(ctaText, false, true);
    /* var address = orderViewModel.store.address + " " + orderViewModel.store.city + " " + orderViewModel.store.stateProvCode + " " + orderViewModel.store.storeCountry;*/
    var store_address = $('#store-info-address').val();
    var city = $('#store-info-city').val();
    var stateProvCode = $('#store-info-state').val();
    var storeCountry = $('#store-info-country').val();
    var addressSection = orderViewModel.store.address ? orderViewModel.store.address : store_address;
    var addressCity = orderViewModel.store.city ? orderViewModel.store.city : city;
    var addressState = orderViewModel.store.stateProvCode ? orderViewModel.store.stateProvCode : stateProvCode;
    var addressCountry = orderViewModel.store.storeCountry ? orderViewModel.store.storeCountry : storeCountry;
    var address = addressSection + " " + addressCity + " " + addressState + " " + addressCountry;
    var pageProtocol = "https:";
    var win = window.open(pageProtocol + "//maps.google.com/maps?daddr=" + encodeURIComponent(address), "_blank", "toolbar=yes,menubar=yes,scrollbars=yes,resizable=yes,location=yes,status=yes,rel=\"noopener noreferrer\"");
    win.focus();
}

function contactStore() {
    var ctaText = $("#store-contact-CTA").text().toLowerCase();
    analytics.curbSideModalConfirmationPage(ctaText, true);
}

function contactStoreDelivery() {
    var ctaText = $("#store-contact-CTA-delivery").text().toLowerCase();
    analytics.curbSideModalConfirmationPage(ctaText, true);
}

function curbSideModalClick() {
    const ctaText = "yes, i am really here";
    analytics.curbSideModalCTA(ctaText);
    modalClose(true);
  //  setTimeout(function () { analytics.curbsideModalClose(); }, 3000);
}

function curbSideModalClickNotHere() {
    const ctaText = "hold on, not yet";
    analytics.curbSideModalCTA(ctaText);
    modalClose(true);
  //  setTimeout(function () { analytics.curbsideModalClose(); }, 3000);
}
function curbSideModalClickOk() {
    var ctaText = $(".margin-top-desk .text-here-ok").text().toLowerCase();
    analytics.curbSideModalCTA(ctaText);
    modalClose(true);
   // setTimeout(function () { analytics.curbsideModalClose(); }, 3000);
}

const UpdateProgressBar = (deliveryStatus, deliveryStatusMessage, data) => {
    deliveryStatus = deliveryStatus.toLowerCase();
    if (deliveryStatus == "" || deliveryStatus == "received") {
        $(".deliveryStatusMessage").text(deliveryStatusMessage);
        $("#order-status-content").show();
        $(".order-status-ontheway").hide();
        $('.progress_wrapper').eq(0).attr('aria-hidden', 'false');
        $('.progress_wrapper').eq(1).attr('aria-hidden', 'true');
        $('.progress_wrapper').eq(2).attr('aria-hidden', 'true');
        $('.progress_wrapper').eq(3).attr('aria-hidden', 'true');
    }
    if (deliveryStatus == "preparing") {
        $(".deliveryStatusMessage").text(deliveryStatusMessage);
        $("#order-status-content").show();
        $(".order-status-ontheway").hide();
        $('.order-status-received').show();
        $('.progress_wrapper').eq(0).removeClass('status-current').addClass('status-done').attr('aria-hidden', 'false');
        $('.progress_wrapper').eq(1).addClass('status-current').attr('aria-hidden', 'false');
        $('.progress_wrapper').eq(2).attr('aria-hidden', 'true');
        $('.progress_wrapper').eq(3).attr('aria-hidden', 'true');
    }
    if (deliveryStatus == "ontheway") {
        $(".deliveryStatusMessage").text(deliveryStatusMessage);
        if (data && data.DeliveryTrackingURL) {
            $('#deliveryTrackingURL').val(data.DeliveryTrackingURL);
        }
        $("#driver-firstname").text(data.FirstName);
        $("#driver-lastname").text(data.LastName);
        $(".order-status-ontheway .contact-driver")[0] && $(".order-status-ontheway .contact-driver")[0].setAttribute("href", "tel: " + data.PhoneNumber);
        $("#order-status-content").show();
        $(".order-status-not-delivered").show();
        $(".order-status-ontheway").show();
        $('.progress_wrapper').eq(0).removeClass('status-current').addClass('status-done').attr('aria-hidden', 'false');
        $('.progress_wrapper').eq(1).removeClass('status-current').addClass('status-done').attr('aria-hidden', 'false');
        $('.progress_wrapper').eq(2).addClass('status-current').attr('aria-hidden', 'false');
        $('.progress_wrapper').eq(3).attr('aria-hidden', 'true');
    }
    if (deliveryStatus == "delivered") {
        $(".deliveryStatusMessage").text(deliveryStatusMessage);
        $("#order-status-content").show();
        $(".order-status-ontheway").hide();
        $('.progress_wrapper').eq(0).removeClass('status-current').addClass('status-done').attr('aria-hidden', 'false');
        $('.progress_wrapper').eq(1).removeClass('status-current').addClass('status-done').attr('aria-hidden', 'false');
        $('.progress_wrapper').eq(2).removeClass('status-current').addClass('status-done').attr('aria-hidden', 'false');
        $('.progress_wrapper').eq(3).addClass('status-current').attr('aria-hidden', 'false');
    }
    if (deliveryStatus == "cancelled") { // if cancelled
        $(".deliveryStatusMessage").text(deliveryStatusMessage);
        $('.i-am-here-class-active').css('visibility', 'hidden');
        $("#cancel-order-content").show();
        $('#order-status-content').hide();
    }
}

const changeTheStatus = function () {
    var $UpdateDeliveryOrderStatus = $('#frmUpdateDeliveryOrderStatus');
    $.ajax({
        url: $UpdateDeliveryOrderStatus.attr('action'),
        type: 'POST',
        data: $UpdateDeliveryOrderStatus.serialize(),
        success: function (data) {
            if (data.HasException) {
                $('#Whoa-there-Error-Title').html(data.ErrorTitle);
                $('#Whoa-there-Error-Msg').html(data.ExceptionMessage);
                $('#Whoa-there-Error-Btn').html(data.Body);
                $('#home-url').val(data.Url);
                $('#Whoa-there-Error-Btnhref').attr("href", data.Url);
                modalShowId('#order-status-error-modal');
            }
            else {
                let driverdetails = null;

                if (data.DeliveryStatus.toLowerCase() == "ontheway") {
                    driverdetails = {
                        FirstName: data.Driver.FirstName,
                        LastName: data.Driver.LastName,
                        PhoneNumber: data.Driver.PhoneNumberForCustomer,
                        TrackingUrl: data.DeliveryTrackingURL
                    }
                }
                if (data.DeliveryStatus.toLowerCase() !== "delivered") {
                    $('#spnETA').text('ETA: ' + data.Driver.DeliveryTime);
                } else if (data.DeliveryStatus.toLowerCase() === "delivered") {
                    $('#spnETA').text(data.Driver.DeliveryTime);
                }
                UpdateProgressBar(data.DeliveryStatus, data.DeliveryStatusMessage, driverdetails);
                $('#subway-spinner').hide();
            }
            $('#subway-spinner').hide();
        },
        error: function (jqXhr) {
            $('#subway-spinner').hide();
            $('#Whoa-there-Error-Title').html(data.ErrorTitle);
            $('#Whoa-there-Error-Msg').html(data.ExceptionMessage);
            $('#Whoa-there-Error-Btn').html(data.Body);
            $('#home-url').val(data.Url);
            $('#Whoa-there-Error-Btnhref').attr("href", data.Url);
            modalShowId('#order-status-error-modal');
        }
    });
};

$(document).ready(function () {
    const currentUrl = window.location.href.toLowerCase();
    if(currentUrl.indexOf('confirmation')>-1){
        orderViewModel.redeemedOffers = [];
        orderViewModel.save();
    }
    if ($('#delivery-order-status-page').length) {
        const $DeliveryOrderStatusAsync = $('#frmDeliveryOrderStatusAsync');
        $('#subway-spinner').show();

        let driverdetails = null;
        orderViewModel.hasLoggedIn ? window.location.href = window.location.href.replace("deliveryorderstatus", "order-confirmation") :
            $.ajax({
                url: $DeliveryOrderStatusAsync.attr('action'),
                type: 'POST',
                data: $DeliveryOrderStatusAsync.serialize(),
                success: function (data) {
                    //analytics.deliveryItemStatus(data.OrderDeliveryStatus);
                    $('#delivery-order-status-page').html(data.DeliveryStatusHtml);
                    var deliveryStatus = data.OrderDeliveryStatus.toLowerCase();
                    var deliveryStatusMessage = data.OrderDeliveryMessage;
                    var width = document.documentElement.clientWidth;

                    $('.order-store-map').hide()
                    if (deliveryStatus.toLowerCase() == "ontheway") {
                        driverdetails = {
                            FirstName: $("#driver-firstname").attr("data-value"),
                            LastName: $("#driver-lastname").attr("data-value"),
                            PhoneNumber: $(".driver-contacting-ways a.driver-phone-number:first").attr("data-value")
                        }
                    }
                    deliveryStatus = deliveryStatus.toLowerCase();
                    if (deliveryStatus == "" || deliveryStatus == "received") {
                        $(".deliveryStatusMessage").text(deliveryStatusMessage);
                        $(".progress-bar").css({ "width": "10%", "background-color": "transparent" });
                        $("#order-status-content").show();
                        $(".order-status-not-delivered").show();
                        $(".order-status-ontheway").hide();
                        $(".order-status-delivered").hide();
                        $('.order-status-marks .mark1').css("visibility", "hidden");
                        $('.progress_wrapper').eq(0).attr('aria-hidden', 'false');
                        $('.progress_wrapper').eq(1).attr('aria-hidden', 'true');
                        $('.progress_wrapper').eq(2).attr('aria-hidden', 'true');
                        $('.progress_wrapper').eq(3).attr('aria-hidden', 'true');
                        if (deliveryStatus.toLowerCase() === "cancelled")
                            $('#divkeepAnEye').hide();
                    }
                    else if (deliveryStatus == "preparing") {
                        $(".deliveryStatusMessage").text(deliveryStatusMessage);
                        $(".progress-bar").css({ "width": "10%", "background-color": "transparent" });
                        $("#order-status-content").show();
                        $(".order-status-not-delivered").show();
                        $(".order-status-ontheway").hide();
                        $(".order-status-delivered").hide();
                        $('.order-status-received').show();
                        $('.order-status-marks .mark1').css("visibility", "hidden");

                        $('.progress_wrapper').eq(0).removeClass('status-current');
                        $('.progress_wrapper').eq(0).addClass('status-done');
                        $('.progress_wrapper').eq(1).addClass('status-current');
                        $('.progress_wrapper').eq(0).attr('aria-hidden', 'false');
                        $('.progress_wrapper').eq(1).attr('aria-hidden', 'false');
                        $('.progress_wrapper').eq(2).attr('aria-hidden', 'true');
                        $('.progress_wrapper').eq(3).attr('aria-hidden', 'true');
                    }
                    else if (deliveryStatus == "ontheway") {
                        $('.progress_wrapper').eq(0).removeClass('status-current');
                        $('.progress_wrapper').eq(0).addClass('status-done');
                        $('.progress_wrapper').eq(1).removeClass('status-current');
                        $('.progress_wrapper').eq(1).addClass('status-done');
                        $('.progress_wrapper').eq(2).addClass('status-current');
                        $('.progress_wrapper').eq(0).attr('aria-hidden', 'false');
                        $('.progress_wrapper').eq(1).attr('aria-hidden', 'false');
                        $('.progress_wrapper').eq(2).attr('aria-hidden', 'false');
                        $('.progress_wrapper').eq(3).attr('aria-hidden', 'true');
                    }
                    else if (deliveryStatus == "delivered") {
                        $(".deliveryStatusMessage").text(deliveryStatusMessage);
                        $(".progress-bar").css({ "width": "100%", "background-color": "#97d700", "border-radius": "20px" });
                        if (width < 1024) {
                            $(".progress-bar-filled ~ img").hide();
                        }
                        else {
                            $(".progress-bar-filled ~ img").hide();
                        }
                        $('.order-status-marks .mark1').css("visibility", "visible");
                        $('.order-status-marks .mark2').css("visibility", "visible");
                        $('.status-oval').addClass("delivery-completed");
                        $(".progress-bar-filled .progress-percent").css("width", "100%");

                        $("#order-status-content").show();
                        $(".order-status-not-delivered").hide();
                        $(".order-status-ontheway").hide();
                        $(".order-status-delivered").show();
                        $('.order-status-received').css('display', 'none');

                        $('.progress_wrapper').eq(0).removeClass('status-current');
                        $('.progress_wrapper').eq(0).addClass('status-done');
                        $('.progress_wrapper').eq(1).removeClass('status-current');
                        $('.progress_wrapper').eq(1).addClass('status-done');
                        $('.progress_wrapper').eq(2).removeClass('status-current');
                        $('.progress_wrapper').eq(2).addClass('status-done');
                        $('.progress_wrapper').eq(3).addClass('status-current');
                        $('.progress_wrapper').eq(0).attr('aria-hidden', 'false');
                        $('.progress_wrapper').eq(1).attr('aria-hidden', 'false');
                        $('.progress_wrapper').eq(2).attr('aria-hidden', 'false');
                        $('.progress_wrapper').eq(3).attr('aria-hidden', 'false');
                    }
                    else if (deliveryStatus == "cancelled") { // if cancelled
                        $(".deliveryStatusMessage").text(deliveryStatusMessage);
                        $('.i-am-here-class-active').css('visibility', 'hidden');
                        $("#cancel-order-content").show();
                        $(".progress-bar-filled ~ img").hide();
                        $(".progress-bar-filled .progress-percent").css("width", "0");
                        $('.order - status - received').css('display', 'none');
                        $('#order-status-content').hide();
                        $('#divkeepAnEye').hide();
                    }
                    $('#subway-spinner').hide();
                },
                error: function (jqXhr) {
                    $('#subway-spinner').hide();
                    $('#Whoa-there-Error-Title').html(data.ErrorTitle);
                    $('#Whoa-there-Error-Msg').html(data.ExceptionMessage);
                    $('#Whoa-there-Error-Btn').html(data.Body);
                    $('#home-url').val(data.Url);
                    $("#Whoa-there-Error-Btnhref").attr("href", data.Url);
                    modalShowId('#order-status-error-modal');
                }
            });
    }
});
